import styled from "styled-components";
import { IMAGES } from "../../../constants/images";
import ContactFormOpen from "../../forms/ContactFormModal/ContactFormOpen";
import { capitalize } from "../../../utils/textUtils";

const ContactModal = ({ toggleModal, level, riskMessage }) => {
  const title = level ? `Wildfire risk: ${capitalize(level)}!` : `Did you identify risk drivers in the blue zones?`;
  const text = riskMessage
    ? `The assessment is based on overall wildfire danger and the provided information. ${riskMessage.text}`
    : "Contact us for practical next steps";

  return (
    <ModalContainer riskColor={riskMessage ? riskMessage.color : "#fff"}>
      <div className="satellite-modal">
        <button className="modal-close" onClick={toggleModal}>
          <img src={IMAGES.CLOSE} alt="close" />
        </button>
        <h4 className="title">{title}</h4>
        <p>{text}</p>
        <ContactFormOpen />
      </div>
    </ModalContainer>
  );
};

const ModalContainer = styled.div`
  position: relative;
  padding: 10px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  border-radius: 8px;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    backdrop-filter: blur(30px);
    -webkit-backdrop-filter: blur(30px);
    z-index: -1;
    border-radius: inherit;
  }

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(to bottom, #fff, ${({ riskColor }) => riskColor});
    z-index: -2;
    border-radius: inherit;
  }

  .satellite-modal {
    padding: 5px;
    text-align: center;

    .title {
      font-size: 16px;
      font-weight: 700;
      margin: 0 10px;
      span {
        color: rgba(0, 0, 255, 1);
      }
    }

    p {
      font-size: 14px;
      margin: 10px 0;

      .risk {
        font-weight: 600;
        color: ${({ riskColor }) => riskColor};
      }
    }

    .modal-close {
      position: absolute;
      background-color: transparent;
      border: none;
      padding: 0;
      top: 10px;
      right: 10px;
      box-shadow: none;
      cursor: pointer;
    }
  }
`;

export default ContactModal;
